import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-secondary-50 border-t border-background-200">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          <div>
            <h4 className="font-heading text-lg font-semibold text-foreground-900 mb-3">
              Yoybuy Sheet
            </h4>
            <p className="text-foreground-600 text-sm leading-relaxed">
              {t('footer_text')}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-3">
              {t('category_title')}
            </h4>
            <div className="grid grid-cols-2 gap-x-4 gap-y-2">
              {categories.map((cat) => (
                <a
                  key={cat.nameKey}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-foreground-600 hover:text-primary-600 text-sm transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  {t(cat.nameKey)}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-3">
              Yoybuy Sheet
            </h4>
            <div className="flex flex-col gap-2">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="whitespace-nowrap inline-flex items-center gap-2 text-foreground-600 hover:text-primary-600 text-sm transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-external-link-line w-4 h-4 flex items-center justify-center"></i>
                {t('btn_yoybuy_sheet')}
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="whitespace-nowrap inline-flex items-center gap-2 text-foreground-600 hover:text-primary-600 text-sm transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-shopping-cart-line w-4 h-4 flex items-center justify-center"></i>
                {t('btn_buy_now')}
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">
            {t('footer_copyright')}
          </p>
          <div className="flex items-center gap-6">
            <span className="text-foreground-400 text-xs cursor-pointer hover:text-foreground-600 transition-colors">
              {t('footer_privacy')}
            </span>
            <span className="text-foreground-400 text-xs cursor-pointer hover:text-foreground-600 transition-colors">
              {t('footer_terms')}
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}